import moment from 'moment'
moment.locale('br');

export default class DateFunction {

  errorMessage = 'Informe a data.'
  placeholder = 'DD/MM/AAAA'
  mask = '##/##/####'
  resetBilling = false

  valid(value) {
    const isValid = moment(value, 'MM/YYYY').isValid() && value.length === 7
    const arrayData = value.split('/')

    const date = new Date();

    const ano = date.getFullYear()
    const mes = date.getMonth() + 1;

    if(arrayData[0] > 12) {
      this.errorMessage = 'Mês deve ser menor que 12'
    }
    if(arrayData[1] > ano) {
      return false
    }

    if(arrayData[1] >= ano && arrayData[0] > mes) {
      return false
    }

    if(+arrayData[1] === ano) {
     this.resetBilling = true
    }else {
      this.resetBilling = false
    }

    return isValid
  }

  error = (value) => {
    if ((value !== '  /    ') && (value !== '')) {
      return !this.valid(value)
    }
    return false
  }

}
